import axios from 'axios';

const MY_SERVER = '/api/'

const getCSRFToken = () => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrftoken='))
    ?.split('=')[1];
};

export const recordGameModeSwitch = async ({ sessionId, newGameMode }) => {
  return axios.post(
    MY_SERVER + 'record_game_mode_switch/',
    { session_id: sessionId, new_game_mode: newGameMode },
    { withCredentials: true, headers: { 'X-CSRFToken': getCSRFToken() } }
  )
  .then((res) => res.data)
  .catch((error) => {
    console.error('Error recording game mode switch:', error);
  });
};

export const recordShots = async ({ sessionId, playerOneShot, playerTwoShot }) => {
  return axios.post(
    MY_SERVER + 'record_shots/',
    { session_id: sessionId, player_one_shot: playerOneShot, player_two_shot: playerTwoShot },
    { withCredentials: true, headers: { 'X-CSRFToken': getCSRFToken() } }
  )
  .then((res) => res.data)
  .catch((error) => {
    console.error('Error recording shots:', error);
  });
};

export const createGameSession = async ({ sessionId, typeOfGame, playerOneGender, playerTwoGender, accessories, gameMode, relationshipType, coupleType }) => {
  return axios.post(
    MY_SERVER + 'start_game_session/',
    {
      session_id: sessionId,
      type_of_game: typeOfGame,
      player_one_gender: playerOneGender,
      player_two_gender: playerTwoGender,
      accessories: accessories,
      game_mode: gameMode,
      relationship_type: relationshipType,
      couple_type: coupleType || 'mixed',
    },
    { withCredentials: true,       headers: {
      'X-CSRFToken': getCSRFToken(), // ✅ This is the key!
    } } // ✅ Correct place — 3rd argument is the config!
  )
  .then((res) => res.data)
  .catch((error) => {
    console.error('Error creating game session:', error);
    throw error;
  });
};
